import { AUTHENTICATION_ROUTE_NAMES } from "@/shared";

export const isAuthRoute = (name) => {
    return Object.values(AUTHENTICATION_ROUTE_NAMES).some(
        (authRouteName) => authRouteName === name
    );
};
